import { constVoid, DOM, IOO, pipe, RR, s, v } from '@packages/prelude'
import { Swiper, SwiperOptions, Navigation, EffectFade } from 'swiper'

import '../css/main.scss'
import 'bootstrap'

const makeSwiper = (selector: string, options: SwiperOptions) =>
  pipe(
    IOO.of({ document }),
    IOO.chain(({ document }) => pipe(document, DOM.querySelector(`#${selector}`)) as IOO.IOOption<HTMLElement>),
    IOO.fold(
      () => constVoid,
      element => IOO.of(new Swiper(element, options))
    )
  )()

const Swipers: Record<string, SwiperOptions> = {
  contactsSwiper: {
    direction: 'horizontal',
    modules: [EffectFade, Navigation],
    slidesPerView: 1,
    navigation: {
      nextEl: '.contacts-button-next',
      prevEl: '.contacts-button-prev'
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    }
  }
}

pipe(
  Swipers,
  RR.foldMapWithIndex(s.Ord)(v.Monoid)((selector, options) => makeSwiper(selector, options))
)
